"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const store_1 = require("@/store");
const index_vue_1 = __importDefault(require("@/views/pages/home/index.vue"));
const index_vue_2 = __importDefault(require("@/views/pages/hotProduct/index.vue"));
const login_1 = require("@/api/login");
const lang_1 = __importDefault(require("@/lang"));
let HeaderTop = class HeaderTop extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
        this.searchWord = '';
    }
    get carNum2() {
        if (!!this.carNum)
            return this.carNum;
        else
            return localStorage.getItem('carNum');
    }
    goAboutUs() {
        let routeData = this.$router.resolve(`/about/index`);
        window.open(routeData.href, '_blank');
    }
    handleCommand(command) {
        localStorage.setItem('language', command);
        lang_1.default.locale = command;
    }
    onLogout() {
        // this.$auth.logout()
        this.$confirm(this.$t('确认退出?'), this.$t('提示'), {
            confirmButtonText: this.$t('确定'),
            cancelButtonText: this.$t('取消'),
            type: 'warning'
        }).then(() => {
            login_1.goOut({ loginToken: this.userInfo.loginToken }).then(() => {
                localStorage.setItem('userInfo', '');
                localStorage.setItem('carNum', '');
                this.$router.push('/login');
            });
        });
    }
    handleSelect(activeLabel) {
        this.setHomeActiveIndex(activeLabel);
    }
    switchChange() {
        window.localStorage.getItem('language') === 'en' ? window.localStorage.setItem('language', 'cn') : window.localStorage.setItem('language', 'en');
        this.$i18n.locale = window.localStorage.getItem('language');
    }
    // token失效
    // onInvalid () {
    //   this.$http.post('/401')
    // }
    search() {
        sessionStorage.setItem('searchWord', this.searchWord);
        this.setAppSearch(this.searchWord);
        if (this.$route.name === '/brand') {
            // this.$emit('search', { label: '综合' })
            location.reload();
        }
        else {
            this.$router.push('/brand/all/');
        }
    }
    goMe() {
        this.$router.replace('/me');
    }
    goHome() {
        this.$router.push('/home');
        this.setHomeActiveIndex('1');
    }
    goShopCar() {
        // if (!this.userInfo) {
        //   this.$router.replace('/login')
        //   return
        // }
        this.$router.push('/car');
    }
    mounted() {
        if (this.$route.name === '/brand') {
            this.searchWord = this.appSearch ? this.appSearch : sessionStorage.getItem('searchWord');
        }
        if (this.$route.name === '/brand' || this.$route.name === '/goodDetail') {
            this.setHomeActiveIndex('2');
        }
        else if (this.$route.name === '/config') {
            this.setHomeActiveIndex('3');
        }
        else if (this.$route.name === '/about') {
            this.setHomeActiveIndex('4');
        }
        else if (this.$route.name === '/news') {
            this.setHomeActiveIndex('5');
        }
    }
};
__decorate([
    vue_property_decorator_1.Prop()
], HeaderTop.prototype, "canTab", void 0);
__decorate([
    store_1.AppModule.State
], HeaderTop.prototype, "carNum", void 0);
__decorate([
    store_1.AppModule.State
], HeaderTop.prototype, "homeActiveIndex", void 0);
__decorate([
    store_1.AppModule.State
], HeaderTop.prototype, "appSearch", void 0);
__decorate([
    store_1.AppModule.Mutation
], HeaderTop.prototype, "setHomeActiveIndex", void 0);
__decorate([
    store_1.AppModule.Mutation
], HeaderTop.prototype, "setAppSearch", void 0);
HeaderTop = __decorate([
    vue_property_decorator_1.Component({
        components: { ProductType: index_vue_1.default, HotProduct: index_vue_2.default }
    })
], HeaderTop);
exports.default = HeaderTop;
